<div class="not-found-container">
  <h1>404</h1>
  <p>Lo sentimos, la página que buscas no existe.</p>
  <button (click)="goHome()">Volver al inicio</button>
</div>
